import React from 'react';
import styled, { css } from 'styled-components';

import { MainForm } from 'helpers/form';
import { usePicture, useText } from 'hooks';
import { MOBILE, DESKTOP, TO_DESKTOP } from 'helpers/styles/media';

const FormBlock = () => {
  return (
    <>
      <Top>{useText('form__title', true)}</Top>
      <Body>
        <MainForm
          labelCss={labelStyles}
          inputCss={inputStyles}
          prefixCss={prefixStyles}
          phoneCss={phoneStyles}
          buttonCss={buttonStyles}
        />
        <Text>{useText('form__text', true)}</Text>
      </Body>
      <Payments>{usePicture(['payments-grey.png', 'payments.png'])}</Payments>
    </>
  );
};

const Top = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  min-height: 55px;
  background-color: #181818;
  color: #ffffff;
  font-size: 25px;
  line-height: 30px;
  font-weight: 700;
  border-radius: 10px 10px 0 0;
`;

const Body = styled.div`
  padding: 12px 16px 16px;
  background: #fff;

  @media ${MOBILE} {
    padding: 16px 16px 12px;
  }
`;

const labelStyles = css`
  margin-bottom: 4px;
  font-size: 15px;
  line-height: 18px;

  @media ${MOBILE} {
    font-size: 14px;
    line-height: 17px;
  }
`;

const inputStyles = css`
  border: 1px solid #ccc;
  border-radius: 5px;
  height: 31px;

  @media ${MOBILE} {
    font-size: 13px;
  }
`;

const prefixStyles = css`
  flex: 0 0 105px;
  input {
    ${inputStyles}
  }
`;

const phoneStyles = css`
  input {
    ${inputStyles}
  }
`;

const buttonStyles = css`
  position: relative;
  border-color: transparent;
  text-align: center;
  min-height: 56px;
  font-size: 24px;
  line-height: 28px;
  font-weight: 700;
  background: linear-gradient(
    0deg,
    #ac7524 3.88%,
    #c18d2f 11.96%,
    #f8cb49 28.97%,
    #ffd34d 31.1%,
    #fee565 58.42%,
    #fded6f 68.35%,
    #e38700 99.88%
  );
  box-shadow: 0 4px 9px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  padding: 0 11px;
  color: #191104;
  text-transform: uppercase;
  transition: transform 0.3s ease;
  will-change: transform;

  @media ${DESKTOP} {
    &:hover {
      transform: scale(1.06);
    }
  }

  @media ${TO_DESKTOP} {
    &:active {
      transform: scale(1.06);
    }
  }
`;

const Text = styled.div`
  font-size: 13px;
  line-height: 16px;
  text-align: center;
  color: #6d6d6d;
`;

const Payments = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 50px;
  background: #efefef;
  border-radius: 0 0 10px 10px;

  @media ${MOBILE} {
    background: #ffffff;
  }

  img {
    height: auto;
    width: 100%;
    max-width: 273px;
    margin: 0 auto;

    @media ${MOBILE} {
      max-width: 314px;
    }
  }
`;

export default FormBlock;
